import { View, Pressable, Image, Platform, Text } from "react-native";
import React from "react";
import { Colors } from "../../../../../globalStyles/ColorConfig";
import CustomComponent from "../../../../../components/CustomComponent";
import GlobalStyles from "../../../../../globalStyles/globalStyles";
import dimensions from "../../../../../globalStyles/dimensions";
import ExperienceIcons from "../../../../../assets/Icons/ExperienceIcons";
import AuthIcons from "../../../../../assets/Icons/AuthIcons";

type ExperienceCardProps = {
  image?: any;
  statusTag: boolean;
  edit?: boolean;
  imgHeight?: any;
  imgStyle?: any;
  tagStyle?: any;
  bgColor?: any;
  data?: any;
  grayImg?: boolean;
  onPress?: any;
};

const ShareCard: React.FC<ExperienceCardProps> = ({
  image,
  statusTag,
  edit,
  imgHeight,
  imgStyle,
  tagStyle,
  bgColor = Colors.white000,
  data,
  onPress,
}) => {
  if (image === null) return null;
  return (
    <View
      style={{
        width: "100%",
        borderRadius: 12,
        overflow: "hidden",
      }}
    >
      <View>
        <Image
          source={{ uri: image }}
          style={[{ width: "100%", height: imgHeight }, imgStyle]}
        />

        {statusTag && (
          <View
            style={[
              {
                position: "absolute",
                height: 30,
                width: Platform.OS === "web" ? 328 : "100%",
                backgroundColor: Colors.gold10,
                opacity: 0.8,
                bottom: 0,
                zIndex: 1,
                justifyContent: "center",
                alignItems: "center",
              },
              tagStyle,
            ]}
          >
            <CustomComponent.TextView
              title={data.status}
              textStyle={[GlobalStyles.captionText, { color: Colors.white10 }]}
            />
          </View>
        )}
      </View>
      <View
        style={{
          width: "100%",
          padding: Platform.OS === "web" ? 10 : dimensions.paddingHorizontal,
          gap: 10,
          backgroundColor: bgColor,
          bottom: 0,
        }}
      >
        <CustomComponent.TextView
          title={data.title}
          textStyle={[
            GlobalStyles.title3,
            {
              fontSize: 24,
              color: Colors.black70,
              fontFamily: "EBGaramondSemiBold",
            },
          ]}
        />
        <View
          style={{
            flexDirection: "row",
            gap: 10,
            width: "100%",
          }}
        >
          <ExperienceIcons.LocationIcon fill={Colors.black100} />
          <Text
            style={{
              fontSize: 15,
              color: Colors.black50,
              fontFamily: "InterRegular",
              width: "80%",
            }}
          >
            {data.place}
          </Text>
          {/* <CustomComponent.TextView
            title={data.place}
            textStyle={[GlobalStyles.bodyText,{
                fontSize: 15,
                color: Colors.black50,
                fontFamily: "InterRegular",
                width: "80%",
            }]}
          /> */}
        </View>
        <View
          style={{
            flexDirection: "row",
            gap: 10,
          }}
        >
          <ExperienceIcons.CalendarIcon fill={Colors.black100} />
          <CustomComponent.TextView
            title={data.date}
            textStyle={[
              GlobalStyles.bodyText,
              {
                fontSize: 15,
                color: Colors.black70,
                fontFamily: "InterRegular",
              },
            ]}
          />
        </View>
        <View
          style={{
            flexDirection: "row",
            gap: 10,
          }}
        >
          <ExperienceIcons.ClockIcon fill={Colors.black100} />
          <CustomComponent.TextView
            title={data.timing}
            textStyle={[
              GlobalStyles.bodyText,
              {
                fontSize: 15,
                color: Colors.black70,
                fontFamily: "InterRegular",
              },
            ]}
          />
        </View>
        {edit && (
          <Pressable onPress={onPress}>
            <View
              style={{
                position: "absolute",
                width: 40,
                height: 40,
                borderRadius: 50,
                borderWidth: 0.5,
                borderColor: Colors.black100,
                right: 0,
                bottom: 0,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AuthIcons.EditIcon fill={Colors.black100} />
            </View>
          </Pressable>
        )}
      </View>
    </View>
  );
};

export default ShareCard;
